import React from 'react'
import '../Styles/Agtek.css'
import Introduction from '../Components/Introduction'
import agteck from '../Assets/logo-agtech3.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import GeographicPresence from '../Components/GeographicPresence'
import MarketAnalysis from '../Components/MarketAnalysis'

function Agtech({ id }) {
  return (
    <section id={id}>
      <Introduction
        id="introduction-agtek"
        srcLogo={agteck}
        altLogo="AgTeck"
        description={
          <>
            A AGTECK se estabelece como uma{' '}
            <span>
              empresa líder no uso de drones para pulverização agrícola
            </span>
            , marcando sua posição através da inovação e eficiência. Com a
            capacidade de pulverizar 1,8 hectares a cada 7 minutos, a AGTECK
            apresenta uma solução ágil e precisa para o manejo de extensas áreas
            agrícolas, servindo algumas das maiores usinas do Brasil! Utilizamos
            o sistema DJI para garantir a máxima performance e precisão em
            nossas operações.
          </>
        }
        color="white"
        img={false}
      />

      <Services id="agteck-service" colorTitle="white">
        <CardServices
          title="Tecnologia de Drones"
          description="A AGTEK tiliza drones para
                cobrir grandes áreas rapidamente, sem a necessidade de veículos pesados que
                compactam o solo. A empresa está em negociações para aplicar sua tecnologia em 2
                milhões de hectares, com expectativa de iniciar suas operações comerciais no segundo
                semestre de 2024. A autonomia e a capacidade de um único equipamento em cobrir
                uma média de 100 hectares por dia, afirma a eficiência e a produtividade dos serviços."
          backgroundColor="white"
          colorTitle="#117E34"
          colorContent="rgb(112, 109, 126)"
          height="300px"
          width="450px"
        />

        <CardServices
          title="Serviços Agrícolas"
          description="Além da pulverização por drones, a AGTEK diversifica sua oferta com a venda direta de
                insumos agrícolas para produtores com distribuição própria. A empresa também se
                envolve no acompanhamento e no plantio, além de importar diretamente peças de
                reposição para venda no varejo. Essa abordagem integrada assegura que os clientes
                da AGTEK tenham acesso a uma rede completa de serviços e produtos para atender
                todas as suas necessidades agrícolas."
          backgroundColor="white"
          colorTitle="#117E34"
          colorContent="rgb(112, 109, 126)"
          height="300px"
          width="450px"
        />
      </Services>

      <MarketAnalysis
        description={
          <>
            O mercado de drones agrícolas está em crescimento, impulsionado pela
            busca por métodos mais eficazes e sustentáveis de gestão de
            cultivos. A aprovação pela ANAC de drones para uso em pulverização
            agrícola, como o modelo XAG P30, indica uma tendência de expansão e
            aceitação regulatória dessas tecnologias no Brasil.
            <br />
            <br /> A capacidade dos drones agrícolas de cobrir até 12 hectares
            por hora destaca o potencial dessa tecnologia para aumentar a
            produtividade e diminuir custos operacionais.
          </>
        }
        backgroundColor="#117E34"
        colorTitle="white"
        colorContent="white"
        colorSvg="white"
      />

      <GeographicPresence
        description={
          <>
            A empresa possui uma presença consolidada no Brasil com sede no
            Paraná, Mato Grosso e Goiânia, atendendo grandes usinas e expandindo
            sua atuação através de parcerias estratégicas. Com equipamentos
            operando em um raio de <span>250 km em sua região base,</span> a
            empresa estende seus serviços ao Rio Grande do Sul, em colaboração
            com a ADS, e ao Rio Grande do Norte, em parceria com o grupo WJ.
            Essas alianças fortalecem a capacidade da AGTEK de atender uma vasta
            gama de clientes em diferentes localidades.
          </>
        }
      />
    </section>
  )
}

export default Agtech
